import React from 'react';
import dynamic from 'next/dynamic';
import * as Dialog from '@radix-ui/react-dialog';
import {
  StyledAlertDialogContent,
  StyledAlertDialogOverlay,
} from '@/shared/ui/alert-dialog/styles';
import { createDialogCloseOnlyHandler } from '@/shared/libs/dialog-open-change';

const CashbackModalContent = dynamic(
  () => import('@/entities/cashback/ui/cashback-modal-content'),
  {
    ssr: false,
    loading: () => null
  }
);

const CashbackModal = ({ visible, onClose }) => {
  return (
    <Dialog.Root open={visible} onOpenChange={createDialogCloseOnlyHandler(onClose)}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay />
        <StyledAlertDialogContent aria-describedby="" data-item="cashback">
          <CashbackModalContent
            onClick={() => onClose()}
          />
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { CashbackModal };
